export class DashboardContents {
    public static None = "None";
    public static ISAAllowanceRemaining = "ISA allowance remaining";
    public static RegularPaymentInAndFrequency = "Regular payment in";
    public static NA = "N/A";
    public static NextRegularWithdrawalDate = "Next regular withdrawal date";
    public static ClientRegularPaymentIn = "Regular payment in";
    public static ThirdPartyRegularPaymentIn = "Regular third party payment in";
    public static EmployerRegularPaymentIn = "Regular employer payment in";
    public static IndividualSDRegularPaymentIn = "Salary deduction payments in";
    public static EmployerSDRegularPaymentIn = "Employer salary deduction payments in";
    public static nextRegularIncomePayment = "Next regular income";
    public static IncomePayment = "Regular income";
    public static nextRegularPaymentIn = "Regular payment in";
    public static zeroValue = "0.00";
    public static nextRegularWithdrawal = "Regular withdrawal";
    public static onPlatformPensionIncomePayment = "Income Payment";
    public static ServiceDown = "Not currently available";
    public static ChangeInValueTooltip1 =
        "This will display £ change over past 12 months where account has been active for > one year";
    public static ChangeInValueTooltip2 = "Where account is < 12 months old this shall be from date of inception";
}

export const DLUAccountPages = [
    "/clients/performance/chargessummarydocument.aspx",
    "/clients/Tracking/Reregistration-transfers.aspx",
    "/clients/orders/orders.aspx",
    "/clients/cash/manageincome.aspx",
    "/clients/orders/isasubscriptions.aspx",
    "/clients/orders/conversions.aspx",
    "/clients/tracking/WIP.aspx",
    "/clients/tracking/WorkCompleted.aspx",
    "/clients/transactions/transactions-cashledger.aspx",
    "/clients/clientdetails/mifirdecisionmakers.aspx",
    "/clients/clientdetails/clientdetails-impairedholdings.aspx",
    "/clients/fees/fees-Clientschedules.aspx",
    "/clients/review/Review-TargetInvestmentSelection.aspx",
    "/clients/reports/Reports-Request.aspx",
    "/clients/reports/reports-requestchargesdisclosure.aspx",
];

export const isDLU = (): boolean => {
    return window.location.pathname.includes(".aspx");
};
